import { FormField } from '../form.field';
import { IFormField } from '../form.interface';

export class DateField<T = string> extends FormField<T> {
  constructor(args?: IFormField<T>) {
    super({ ...args, ...{ bidi: true, inputType: 'tel', inputMode: 'numeric', inputMethod: 'typing' } });
  }
}
